<template>
  <v-dialog max-width="80%" v-model="dialog">
      <template v-slot:activator={on}>
          <v-btn outlined v-on=on>
            <v-icon left>mdi-cloud-download</v-icon>Download Invoices
           </v-btn>
      </template>
      <v-card>
          <v-card-title>Download Invoices</v-card-title>
          <v-card-text>
            <v-data-table
                :headers="headers"
                :items="downloadList"
                :loading="loading"
                v-if="!form"
            >
                <template v-slot:item.shop="{item}">
                    {{item.shopId==1?'Miura': 'TrueSpec'}}
                </template>
                <template v-slot:item.month="{item}">
                    {{item.month}}/{{item.year}}
                </template>
                <template v-slot:item.download="{item}">
                    <download
                        v-if="item.filePath"
                        label="Download"
                        url="clients/downloadZip"
                        :filename="'invoice-'+item.year+'.zip'"
                        :data="{ id: item.id, clientId }"
                    ></download>
                </template>
            </v-data-table>

            <v-form v-if="form" ref="form" v-model="valid" lazy-validation>
                <v-layout row>
                    <v-row>
                        <v-col>
                            <v-select :items="years" v-model="model.year" label="Year"></v-select>
                        </v-col>
                    </v-row>
                    
                </v-layout>
            </v-form>

          </v-card-text>
          <v-card-actions>
              <v-btn text @click="dialog=false">Close</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="newExport" v-if="!form">New export</v-btn>
              <v-btn @click="saveNewExport" v-else>Save</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import Download from "@components/Download.vue";
import { mapActions, mapGetters } from 'vuex'
export default {
    components:{
        Download,
    },
    props:{
        clientId:{
            type:Number,
            required:true
        }
    },
    data: () => ({
        dialog:false,
        headers:[
            {text:'Year', value:"year"},
            {text:'Status', value:"status"},
            {text:'Download', value:"download"}
        ],
        years:[
            {value:2019, text:"2019"},
            {value:2020, text:"2020"},
            {value:2021, text:"2021"},
            {value:2022, text:"2022"},
        ],
        form:false,
        loading:false,
        valid:false,
        model:{}
    }),
    watch:{
        dialog:function(){
            this.loading=true;
            this.getDownloadList(this.clientId).finally(() => {this.loading=false})
        }
    },
    computed:{
        ...mapGetters("clients", ["downloadList"])
    },
    methods:{
        ...mapActions("clients", ["getDownloadList","createDownloadInvoice"]),
        newExport(){
            this.form=true
        },
        saveNewExport(){
            this.model.clientId = this.clientId
            this.createDownloadInvoice(this.model).finally(() => {
                this.form=false
            })
        }
    }
}
</script>

<style>

</style>